import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'controllers'

import '../css/application.css'

